import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountPINService } from '../../../services/accountPin.service';
import { AppState } from '../../app.service';
import { ModalService } from '../../../services/modal.service';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

export class AccountPinRetrievalContext {
  public mdn: string;
}
@Component({
  selector: 'app-account-pin-retrieval',
  imports: [CommonModule, TranslateModule],
  templateUrl: './account-pin-retrieval.component.html',
  styleUrl: './account-pin-retrieval.component.scss'
})
export class AccountPinRetrievalComponent {
  private dialog = inject(MatDialogRef<AccountPinRetrievalContext>);
  public data = inject(MAT_DIALOG_DATA);
  public hideModal = false;
  private accountPINService = inject(AccountPINService);
  private translate = inject(TranslateService);
  private appState = inject(AppState);
  private modalHelper = inject(ModalService);

  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(res?: any): void {
    this.beforeClose();
    this.dialog.close(res);
  }

  getPin(): void {
    if(this.data?.mdn) {
      this.appState.loading = true;
      this.accountPINService.getPin(this.data?.mdn).then(res => {
        this.dialog.close();
        this.appState.loading = false;
        this.modalHelper.successModal({ msg: this.translate.instant('success-modal.account-pin-sent-successfully') });
      }, (error) => {
        this.hideModal = true;
        this.appState.loading = false;
        this.modalHelper.failureModal({ msg: this.translate.instant('failure-modal.error-pin') }).afterClosed().subscribe((res => {
          this.hideModal = false;
        }))
      })
    }
  }
}
